import { render, staticRenderFns } from "./modalEditarTermino.vue?vue&type=template&id=0284d5c0&scoped=true"
import script from "./modalEditarTermino.vue?vue&type=script&lang=js"
export * from "./modalEditarTermino.vue?vue&type=script&lang=js"
import style0 from "./modalEditarTermino.vue?vue&type=style&index=0&id=0284d5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284d5c0",
  null
  
)

export default component.exports